export const nav = [
  {
    type: 'section',
    title: '',
    items: [
      {
        type: 'link',
        title: 'Dashboard',
        name: 'dashboard',
        path: '/dashboard',
        data_tour: 'dashboard'
      }
    ]
  },
  {
    type: 'section',
    title: 'People',
    has_horizontal_rule: true,
    items: [
      {
        type: 'link',
        title: 'Contacts',
        name: 'people',
        path: '/contacts',
        data_tour: 'contacts',
        hide_if: (payload) => {
          return !payload.permissions['contact:view'];
        }
      },
      {
        type: 'link',
        title: 'Audiences',
        name: 'groups',
        path: '/audiences',
        data_tour: 'audiences',
        permission: 'audience:view',
        hide_if: (payload) => {
          return !payload.permissions['audience:view'];
        }
      }
    ]
  },
  {
    type: 'section',
    title: 'Messaging',
    has_horizontal_rule: true,
    items: [
      {
        type: 'link',
        title: 'Campaigns',
        name: 'campaign',
        path: '/campaigns',
        data_tour: 'campaigns',
        permission: 'campaign:view',
        hide_if: (payload) => {
          return !payload.permissions['campaign:view'];
        }
      },
      {
        type: 'link',
        title: 'Transactional Email',
        name: 'transactional',
        path: '/transactionals',
        permission: 'transactional:view',
        hide_if: (payload) => {
          return !payload.permissions['transactional:view'];
        }
      },
      {
        type: 'link',
        title: 'SMS',
        name: 'sms',
        path: '/sms'
      },
      // {
      //   type: 'link',
      //   title: 'WhatsApp',
      //   name: 'whatsapp',
      //   path: '/whatsapp'
      // },
      {
        type: 'link',
        title: 'Mobile Push',
        name: 'mobile_push',
        path: '/mobile'
      },
      {
        type: 'link',
        title: 'Web Push',
        name: 'web_push',
        path: '/web'
      }
    ]
  },
  {
    type: 'section',
    title: 'Automations',
    is_web_only: true,
    has_horizontal_rule: true,
    items: [
      {
        type: 'link',
        title: 'Journeys',
        name: 'automation',
        path: '/workflows',
        hide_if: (payload) => {
          return !payload.permissions['automation:view'];
        }
      },
      {
        type: 'link',
        title: 'Auto Responder',
        name: 'auto_responder',
        path: '/neurons',
        hide_if: (payload) => {
          return !payload.permissions['automation:view'];
        }
      },
      {
        type: 'link',
        title: 'Triggers',
        name: 'bolt',
        path: '/triggers',
        hide_if: (payload) => {
          return !payload.permissions['automation:view'];
        }
      }
    ]
  },
  {
    type: 'section',
    title: 'Administration',
    has_horizontal_rule: true,
    items: [
      {
        type: 'link',
        title: 'SMS Sender IDs',
        name: 'id',
        path: '/sender-ids'
      },
      {
        type: 'link',
        title: 'Users',
        name: 'users',
        path: '/users/invitations',
        hide_if: (payload) => {
          return !payload.permissions['user_management:view'];
        }
      },
      { type: 'link', title: 'Tutorial', name: 'book', path: '/tutorials' },
      {
        type: 'link',
        title: 'Integrations',
        name: 'extension',
        path: '/integrations',
        hide_if: (payload) => {
          return !payload.permissions['integration:view'];
        }
      }
    ]
  }
];
